import React from 'react';
import { Typography } from '@mui/material';

export const RequiredAsterisk = () => {
    return (
        <Typography component="span" color="error" fontSize={24} sx={{ marginLeft: '2px', marginTop: '-5px' }}>
            *
        </Typography>
    );
};
